module.exports = __webpack_public_path__ + "img/photo1.jpg.a5b4db0f.webp";